









































































































































































































import {namespace} from 'vuex-class';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {validatorMail} from "@/helpers/validators";

import Alert from '@/components/UI/Alert.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import TooltipWithClose from '@/components/UI/TooltipWithClose.vue';

const dialog = namespace('dialog')
const resources = namespace('resources')
const profile = namespace('profile')

@Component({
  components: {
    Alert,
    BtnDefault,
    TooltipWithClose,
  },
  name: "Company"
})
export default class Company extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('setSupportDialog') protected setSupportDialog: any
  @dialog.Mutation('setSupportDialogOption') protected setSupportDialogOption: any
  @resources.Getter('getCountries') protected getCountries: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any
  @resources.Action('getCountryFromServerHard') protected getCountryFromServerHard: any
  @profile.Action('checkExistCompany') protected checkExistCompany: any
  @profile.Getter('getIsExistCompany') protected getIsExistCompany: any
  
  @Prop({type: [Number], default: 1}) step !:any
  @Prop({type: [Boolean], default: false}) save !:any

  companyStep1:any = {
    site: '',
    email: '',
    phone: '',
    title: '',
  }
  companyStep2:any = {
    tax: '',
    country: '',
    postcode: '',
    region: '',
    city: '',
    address: '',
  }
  error:any = {
    site: '',
    email: '',
    phone: '',
    title: '',
    country: '',
    postcode: '',
    region: '',
    city: '',
    address: '',
  }
  tooltip:any = {
    site: false,
    email: false,
    phone: false,
    title: false,
    country: false,
  }
  isError:boolean = false
  loading:boolean = false
  search:string = ''
  country:any = ''

  mounted() {
    this.getCountryFromServer()
  }

  @Watch('save')
  checkCompany() {
    if(this.save) {
      let params = {...this.companyStep1,
        title: this.companyStep1.title,
        tax: this.companyStep2.tax,
        location: {
          _country: this.companyStep2.country,
          postcode: this.companyStep2.postcode,
          region: this.companyStep2.region,
          city: this.companyStep2.city,
          address: this.companyStep2.city
        }
      }
      this.$emit('addNewCompany', params)
    }
  }

  validEmail(email:string) {
    return validatorMail(email)
    // let re =  /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
    // return re.test(email)
  }

  validPhone(phone:string) {
      let re = /^[\d\+][\d\(\)\ -]{4,20}\d$/
      return re.test(phone)
  }

  async next() {
    this.loading = true
    let flag = true
    for(let key in this.companyStep1) {
      if(!this.companyStep1[key]) {
        this.error[key] = 'empty'
        flag = false
      }
    }
    if(flag) {
      if(!this.validEmail(this.companyStep1.email)) {
        this.error.email = 'invalid'
        flag = false
      }
      if(!this.validPhone(this.companyStep1.phone)) {
        this.error.phone = 'invalid'
        flag = false
      }
    }
    if(flag) {
      await this.checkExistCompany({
        email: this.companyStep1.email,
        phone: this.companyStep1.phone,
        site: this.companyStep1.site,
        title: this.companyStep1.title
      })
      if(!this.getIsExistCompany) this.$emit('changeStep', 2)
    }
    this.loading = false
  }

  showSupport() {
    this.setSupportDialog(true)
    this.setSupportDialogOption('duplicate_company')
  }

  reset(prop:string) {
    this.error[prop] = ''
  }

}
